import { useState } from "react";

import { InvoicesTab } from "../../components/invoices/InvoicesTab";
import { IssueCreditModal } from "../credits/IssueCreditModal";
import { InvoiceInformationPanel } from "./components/InvoiceInformationPanel";

interface AdminInvoicesTabProps {
  readonly limit: number;
  readonly onLimitChange: (limit: number) => void;
  readonly onPageChange: (page: number) => void;
  readonly page: number;
  readonly projectId: number;
}

export function AdminInvoicesTab({
  projectId,
  ...invoicesTabProps
}: AdminInvoicesTabProps) {
  const [creditInvoiceId, setCreditInvoiceId] = useState<null | string>(null);

  return (
    <div className="flex flex-col gap-xl p-xl lg:flex-row lg:items-start">
      <div className="lg:w-[270px] lg:shrink-0">
        <InvoiceInformationPanel projectId={projectId} />
      </div>

      <div className="min-w-0 flex-1 overflow-hidden rounded-xl border border-border-secondary bg-bg-primary">
        <InvoicesTab
          {...invoicesTabProps}
          onIssueCredit={(invoice) => setCreditInvoiceId(invoice.id)}
          projectId={projectId}
        />
      </div>

      {creditInvoiceId && (
        <IssueCreditModal
          invoiceId={creditInvoiceId}
          onClose={() => setCreditInvoiceId(null)}
          projectId={projectId}
        />
      )}
    </div>
  );
}
